import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AuthInterceptor, EventTypes, OidcSecurityService, PublicEventsService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from '../login/login.component';
import { UnauthorizedComponent } from '../unauthorized/unauthorized.component';
import { AuthConfigModule } from './app-config.module';
import { AccountService } from 'src/shared/services/account.service';
import { ServiceUtil } from 'src/shared/utilities/service.util';
import { TrackingUtil } from 'src/shared/utilities/tracking.util';
import { PlatformService } from 'src/shared/services/platform.service';
import { ProfileService } from 'src/shared/services/profile.service';
import { UserAdminService } from 'src/shared/services/user-admin.service';
import { SgPortalDataApiServiceUtil } from 'src/shared/utilities/sgportal-data-api.service.util';
import { WebEventTrackingService } from 'src/shared/services/web-event-tracking.service';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppModule as ApplicationModule } from '../../app/app.module';
import { ConfigService } from 'src/shared/services/config.service';
import { LogoutComponent } from '../logout/logout.component';
import { NotFoundComponent } from './not-found.component';
import { ConcurrentComponent } from '../concurrent/concurrent.component';
import { ApplicationsService } from 'src/shared/services/applications.service';
import { PreviousRouteService } from 'src/shared/services/previous-route-service';
import { BaseComponent } from 'src/shared/components/base-component.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HHSGSharedComponentsModule, HhsgSharedCommonModule, HhsgSharedDevExtremeModule, HhsgSharedLayoutModule, XsrfInterceptor } from '@hhsg/hhsg-shared-components';
import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/shared/services/loading.service';
import { DevExtremeModule } from 'devextreme-angular';
import { SideNavHeaderService } from 'src/shared/services/side-nav-header.service';
import { AspDataStoreService } from 'src/shared/services/asp-data-store.service';

export const getConfigUrl = () => {
    var configProd = `app-settings.json`, 
            configQA = `app-settings.development.json`, 
            configDev = `app-settings.development.json`, 
            configMock = `app-settings.development.json`, 
            configDockerLocal = `app-settings.dockerlocal.json`;

    return { 'PROD': configProd, 'QA': configQA, 'DEV': configDev, 'MOCK': configMock, 'DockerLocal': configDockerLocal }[ environment.type ];
};

const HapServices = [
    AccountService, 
	ApplicationsService, 
	ServiceUtil, 
	TrackingUtil,
	PlatformService, 
	ProfileService,
	UserAdminService,
	SgPortalDataApiServiceUtil, 
	PreviousRouteService,
	WebEventTrackingService,
	LoadingService
];

@NgModule({
    declarations: [ 
        AppComponent,
		BaseComponent,
		ConcurrentComponent,
		LogoutComponent,
		LoginComponent,
		NotFoundComponent,
		UnauthorizedComponent
    ],
    imports: [
        BrowserModule,
		BrowserAnimationsModule,
		ApplicationModule,
		AppRoutingModule,
		HttpClientModule,
		HttpClientXsrfModule.withOptions({
			cookieName: 'HAP-XSRF-TOKEN'
		}),
        AuthConfigModule,
        FormsModule, 
		DevExtremeModule,
        HHSGSharedComponentsModule.forRoot(getConfigUrl(), environment as any),
		HhsgSharedCommonModule,
		HhsgSharedDevExtremeModule,
		HhsgSharedLayoutModule  
    ],
    providers: [ 
        ConfigService, 
        DatePipe, 
        HapServices, 
        OidcSecurityService,
		SideNavHeaderService,
		AspDataStoreService,
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
			provide: APP_BASE_HREF,
			useFactory: (config: ConfigService) => config.appSettings.angularRoot,
			deps: [ConfigService]
		},
		{ provide: HTTP_INTERCEPTORS, useClass: XsrfInterceptor, multi: true }
    ],
    bootstrap: [ AppComponent ]
})
export class AppModule {
    constructor(private readonly eventService: PublicEventsService) {
        this.eventService
            .registerForEvents()
            .pipe(filter((notification) => notification.type === EventTypes.ConfigLoaded))
            .subscribe((config) => {
                console.log('ConfigLoaded', config);
            });
  }
}